<script lang="ts">
	import BackToOverview from '@components/BackToOverview.svelte';
	import DynamicComponentMapper from '@components/DynamicComponentMapper.svelte';
	import { getComponentProps, pageUsesCmsEventTicketsComponent } from '$lib/cmsComponentMapping.js';
	import Breadcrumbs from '@components/Breadcrumbs.svelte';
	import type { IEventFilterSelectionsStore } from '@stores/eventFilterSelections.js';
	import { getContext, onMount } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { getUserType, sanitizeEventPageParams, setPageView } from '$lib/tracking.js';
	import { resetCriticalUserData } from '@stores/user.js';

	const eventFilterSelections = getContext<Writable<IEventFilterSelectionsStore>>(
		'eventFilterSelectionsStore'
	);
	$eventFilterSelections.eventTicketsSearchText = '';

	export let data;

	// TODO: Check fix for reactivity
	let currentEvent;
	let additionalAggregatedEventData;
	let cmsComponentBlocks;
	let cmsMediaBlocks;
	let relatedEvents;

	$: if (data) {
		({
			currentEvent,
			additionalAggregatedEventData,
			cmsComponentBlocks,
			cmsMediaBlocks,
			relatedEvents
		} = data);
	}

	onMount(() => {
		resetCriticalUserData();
		setPageView({
			page_type: 'event.individual',
			page_category_1: 'event',
			page_category_2: 'event',
			page_category_3: 'event',
			page_product_catalog: 'event',
			page_content_id: `erlebenwasverbindet.telekom.de.privatkunden.${currentEvent?.slug || ''}`,
			shop_customer_type: getUserType(),
			user_type: getUserType(),
			user_login_status: 'not-logged-in',
			event_name: sanitizeEventPageParams(currentEvent?.name || ''),
			event_date: '',
			event_location: ''
		});
	});
</script>

<div>
	<Breadcrumbs
		links={[{ href: '/', label: 'Mehr Magenta Events' }, { label: currentEvent?.name || '' }]}
	/>

	{#if cmsComponentBlocks?.length}
		{#each cmsComponentBlocks as block, i}
			<DynamicComponentMapper
				{block}
				id={i > 0 && cmsComponentBlocks[i - 1]?.resource_class_name === 'DetailHeader'
					? 'details'
					: block.anchor}
				{...getComponentProps({
					currentEvent,
					additionalAggregatedEventData,
					cmsComponentBlock: block,
					cmsMediaBlocks,
					relatedEvents,
					usesCmsEventTicketsComponent: pageUsesCmsEventTicketsComponent(cmsComponentBlocks),
					componentIndex: i
				})}
			/>
		{/each}
	{/if}

	<BackToOverview />
</div>
